export default {
    adjustments: {
        title: "Ajustes",
        reset: "Restablecer",
        light: {
            title: "Luz",
            brightness: "Brillo",
            contrast: "Contraste",
            shadows: "Sombras",
        },
        color: {
            title: "Color",
            saturation: "Saturación",
            temperature: "Temperatura",
            blacks: "Negros",
            whites: "Blancos",
        },
        detail: {
            title: "Detalle",
            clarity: "Claridad",
            sharpness: "Agudeza",
            blur: "Desenfoque",
        },
    },
};
